import { cloneDeep } from 'lodash'
import { ITimeSlotOption } from 'components/Calendar/EventForm'

export const getTimeOptions = (timeSlotOptions: ITimeSlotOption[]) => {
  timeSlotOptions = cloneDeep(timeSlotOptions)
  const slotOptions = timeSlotOptions
  if (timeSlotOptions.length === slotOptions.length) timeSlotOptions.pop()

  return timeSlotOptions
}
